import axios from 'axios';

export default {
    listWorkposts() {
        return axios.post('/workpost/listWorkposts/');
    },
};
